module.exports = __webpack_public_path__ + "static/header-image-03-3c4497d804cabbc34723c7d57063d120.png";